<template>
  <div class="editor-content-item-layout">
    <template v-if="itemCurrent && itemCurrent.content">
      <div class="options-actions">
        <span>{{ $t(`ct-${type}`)}} - {{ itemCurrent.name}} </span>
<!--        <router-link target="_blank" :to="{ name: 'Page', params: { id: page_id, layout_id: layout_id, website_id: website_id, action : `${type}-settings`  }}">-->
<!--          <img src="static/images/icons/engrenagem.svg"-->
<!--               class="svg-icon normal-action"-->
<!--               v-tooltip="{content:$t('ct-page-settings'),  class: 'tooltip-custom'}"-->
<!--          />-->
<!--        </router-link>-->

        <router-link target="_blank" :to="{ name: 'editor-layout-item', params: { 'id_item' : itemCurrent.encrypted_id, type: type , website_id : website_id  }}">
          <img src="static/images/icons/editar.svg"
               v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
               class="svg-icon normal-action"/>

        </router-link>
      </div>

      <component v-for="(element) in itemCurrent.content" :is="element.name" :config="element.config"
                 :key="`${element.id}-${item.id}`"
                 :id="element.id" :childs="element.childs" :device="device" :preview="preview" class="editor-content-item-element">
      </component>

    </template>
  </div>
</template>

<script>
import PanelElement from './../../apps/Panel/Panel.vue';

export default {
  name: 'HeaderFooter',
  props: ['type', 'item', 'page_id', 'website_id', 'layout_id', 'device', 'preview'],
  components: {
    PanelElement
  },
  data() {
    return {
      itemCurrent: {}
    };
  },
  watch: {
    'device': function(value) {
      this.setElement();
    },

    'item': function(value) {
      this.setElement();
    }
  },
  methods: {
    setElement() {
      if (this.preview && this.item && this.device && typeof this.item[this.device] !== 'undefined') {
        this.itemCurrent = this.item[this.device];
      } else {
        this.itemCurrent = false;
      }
    }
  },
  mounted() {
    this.setElement();
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/base/editor/HeaderFooter.vue